// The phone's + button: a short menu of quick actions, nothing else. Add a Contact opens the one-door intake; Add a Task is a one-line sheet (title, due Today or Tomorrow, Save: nothing required but the
// title); Log a Note and Log a Sighting open the existing HUNT screens (they are not rebuilt here); Voice Note is shown as Coming Soon until the transcription service exists.
import React, { useState } from 'react';
import { useAppContext } from '../lib/AppContext';
import AddTaskSheet from './AddTaskSheet';
import { openQuickOrder } from '../modules/quickorder/quickOrderLauncher';
import { readableTextOn } from '../lib/styles';
import { THEME_2026 } from '../lib/theme2026';

const item = { display: 'flex', alignItems: 'center', minHeight: 48, padding: '0 18px', borderRadius: 24, background: '#fff', border: '1px solid var(--gov-line, #e2e8f0)', boxShadow: '0 3px 12px rgba(0,0,0,0.15)', fontSize: 16, fontWeight: 700, color: 'var(--gov-ink, #1a2133)', cursor: 'pointer', whiteSpace: 'nowrap' };

export default function PhonePlusMenu({ onNavigate }) {
  const { activePartner } = useAppContext();
  const accent = (activePartner && activePartner.brand_color) || THEME_2026.brassAccent;
  const [open, setOpen] = useState(false);
  const [sheet, setSheet] = useState(false);
  const go = (key, params) => { setOpen(false); if (onNavigate) onNavigate(key, params); };

  return (
    <>
      {open && (
        <>
          <div onClick={() => setOpen(false)} style={{ position: 'fixed', inset: 0, zIndex: 479 }} />
          <div data-testid="plus-menu" style={{ position: 'fixed', right: 20, bottom: 148, zIndex: 481, display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'flex-end' }}>
            <button type="button" style={item} onClick={() => { setOpen(false); openQuickOrder(); }}>Quick Order</button>
            <button type="button" style={item} onClick={() => go('contacts', { quickAdd: true })}>Add a Contact</button>
            <button type="button" style={item} onClick={() => { setOpen(false); setSheet(true); }}>Add a Task</button>
            <button type="button" style={item} onClick={() => go('whistle-hunt')}>Log a Note</button>
            <button type="button" style={item} onClick={() => go('bird-dog-list')}>Log a Sighting</button>
            <button type="button" disabled style={{ ...item, opacity: 0.5, cursor: 'default' }}>Voice Note (Coming Soon)</button>
          </div>
        </>
      )}
      <button type="button" aria-label="Open Quick Add" onClick={() => setOpen((o) => !o)}
        style={{ position: 'fixed', right: 20, bottom: 84, width: 52, height: 52, borderRadius: '50%', background: accent, color: readableTextOn(accent), border: '2px solid #ffffff', boxShadow: '0 4px 14px rgba(0,0,0,0.25)', cursor: 'pointer', zIndex: 480, fontSize: 24, fontWeight: 700, padding: 0, transform: open ? 'rotate(45deg)' : 'none', transition: 'transform 0.18s ease' }}>+</button>

      <AddTaskSheet open={sheet} onClose={() => setSheet(false)} />
    </>
  );
}
